export const NOTIFICACIONES_ADD = 'NOTIFICACIONES#ADD';
